import {PlayersStatisticsTableColumnGroupApiModel} from "./players-statistics.table.column-group.api-model";
import {BaseDomainModel} from "../../../../../../infrastructure/models/base-domain-model";

export class PlayersStatisticsTableColumnGroupDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsTableColumnGroupApiModel;

  get order(): Number {
    return this.apiModel.order;
  }

  get name(): String {
    return this.apiModel.name;
  }
}
